module.exports =(function() {
  return function(context) {
    return (function() {
      var $o;
      $o = [];
      $o.push("<div class='header-assets-wrapper'>\n  <h4 class='asset-image-count'></h4>\n  <div class='toggle-asset-view'></div>\n</div>\n<div class='thumbnail-container'></div>");
      return $o.join("\n").replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/platform/templates/assets/assets_collection_tile.js.hamlc
// module id = 1561
// module chunks = 18